import React from 'react';
import {Route, Redirect, useHistory} from 'react-router-dom';
import {connect} from 'react-redux';
import get from 'lodash/get';

// Auth
import Login from './Login';
import Register from './Register/index';
import ForgotPassword from './ForgotPassword';
import SetNewPasswordForm from './SetNewPasswordForm';
import RetailCRM from './RetailCRM'
import {SHOP_SOURCE_ONE_MESSAGE} from "../../constants";
import {authByLink} from "../../thunks/Auth";

import Preloader from '../../Components/Preloader';


const Auth = (
    {
        match,
        location,
        activeShop,

        authByLink,
    }
) => {
    let history = useHistory();

    return (activeShop && !location.pathname.startsWith('/auth/retailcrm/register') ? (
                    (get(activeShop, 'source') === SHOP_SOURCE_ONE_MESSAGE) ?
                        <Redirect to={`/${activeShop.id}/flows/`}/>
                    :
                        <Redirect to={`/${activeShop.id}/dashboard/`}/>
                ) : (
                    <div className="app-container">
                        <Route path={`${match.url}/login`} component={Login}/>
                        <Route path={`${match.url}/register`} component={Register}/>
                        <Route path={`${match.url}/forgot-password`} component={ForgotPassword}/>
                        <Route path={`${match.url}/set-new-password`} component={SetNewPasswordForm}/>
                  
                        {/* Partners registration */}
                        <Route path={`${match.url}/retailcrm/register/:messenger`} component={RetailCRM}/>

                        {/* auth by link */}
                        <Route path={`${match.url}/auth-by-link/:auth_token/:shop_id/:bot_id`} component={({match: {params}}) => {
                            authByLink(params.auth_token, params.shop_id, params.bot_id, () => {
                                history.push(`${match.url}/auth-by-link-error`);
                            });
                            return <Preloader/>;
                        }}/>
                        <Route path={`${match.url}/auth-by-link-error`} render={() => {
                            return (
                                <div className="loader-container">
                                    <div className="loader-container-inner">
                                        <h6 className="mt-3">
                                            An error has occurred
                                            <small>Check transmitted data</small>
                                        </h6>
                                    </div>
                                </div>
                            );
                        }}/>
                    </div>
                )
           )
};

const mapStateToProps = state => ({
    activeShop: state.Shops.activeShop,
});

const mapDispatchToProps = dispatch => ({
    authByLink: (authToken, shopId, botId, errorCallback) => dispatch(authByLink(authToken, shopId, botId, errorCallback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
